/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `free` - 무료
 * `basic` - Basic
 * `pro` - Pro
 */
export type TierEnum = (typeof TierEnum)[keyof typeof TierEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TierEnum = {
  free: "free",
  basic: "basic",
  pro: "pro",
} as const;
